<section class="content resources-shell">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="'Bulk Setup Upload'"
        [items]="['Outstations']"
        [active_item]="'Bulk Upload'"
      ></app-breadcrumb>
    </div>

    <div class="upload-container mat-elevation-z3">
      <div class="page-actions">
        <button mat-stroked-button class="upload-outline-btn" (click)="goBack()">
          View Outstations
        </button>
      </div>

      <h2>Bulk Outstation & Community Setup</h2>
      <p class="upload-description">
        Download the combined workbook, fill the <strong>Outstations</strong> sheet first, then use the same
        <strong>Outstation Name</strong> on the <strong>Communities</strong> sheet to attach communities to the right outstation.
      </p>

      <div class="instruction-card">
        <div class="instruction-title">Before you upload</div>
        <ul>
          <li>Fill the <strong>Outstations</strong> sheet first — each row creates one outstation under your parish.</li>
          <li>Outstation Name is required. Location is optional.</li>
          <li>Outstations that already exist will be <strong>skipped</strong> — no duplicates are created.</li>
          <li>On the <strong>Communities</strong> sheet, Outstation Name must match exactly the name in the Outstations sheet (or an existing outstation).</li>
          <li>Community Name and Outstation Name are required on every community row.</li>
          <li>Communities that already exist under their outstation will be skipped.</li>
          <li>Upload the combined workbook once both sheets are filled.</li>
        </ul>
      </div>

      <div class="upload-row">
        <button type="button" mat-raised-button class="upload-dark-btn" (click)="openFilePicker()">
          <mat-icon>upload_file</mat-icon>
          Select Workbook
        </button>
        <input
          #fileInputRef
          type="file"
          accept=".xls,.xlsx"
          (change)="onFileSelected($event)"
          hidden
        />
        <span class="file-name">{{ selectedFile?.name || 'No file chosen' }}</span>

        <div class="button-group">
          <button
            mat-raised-button
            class="upload-green-btn"
            (click)="uploadFile()"
            [disabled]="!selectedFile || uploading || downloadingTemplate"
          >
            {{ uploading ? 'Processing...' : 'Upload Workbook' }}
          </button>

          <button
            mat-raised-button
            class="upload-orange-btn"
            (click)="downloadTemplate()"
            [disabled]="uploading || downloadingTemplate"
          >
            <span class="button-spinner" *ngIf="downloadingTemplate"></span>
            {{ downloadingTemplate ? 'Downloading...' : 'Download Template' }}
          </button>
        </div>
      </div>

      <div class="upload-status" *ngIf="uploading">
        The workbook is being processed. Outstations are created first, then communities are matched to their outstation by name.
      </div>

      <div class="result-banner" *ngIf="uploadMessage">
        {{ uploadMessage }}
      </div>

      <div class="results-grid" *ngIf="resultSections.length">
        <div class="result-card" *ngFor="let section of resultSections">
          <div class="result-card-header">
            <h3>{{ section.title }}</h3>
            <span class="result-pill">{{ getProcessedRows(section.summary) }} rows</span>
          </div>

          <div class="result-stats">
            <div class="stat-box">
              <span>Processed</span>
              <strong>{{ getProcessedRows(section.summary) }}</strong>
            </div>
            <div class="stat-box">
              <span>Created</span>
              <strong>{{ getSuccessfulRows(section.summary) }}</strong>
            </div>
            <div class="stat-box">
              <span>Skipped</span>
              <strong>{{ getSkippedRows(section.summary) }}</strong>
            </div>
            <div class="stat-box">
              <span>Failed</span>
              <strong>{{ getFailedRows(section.summary) }}</strong>
            </div>
          </div>

          <div class="table-wrapper" *ngIf="getRows(section.summary).length; else noRows">
            <table>
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of getRows(section.summary); trackBy: trackByRow">
                  <td>{{ row.rowNumber || '-' }}</td>
                  <td>{{ resolveNameLabel(row) }}</td>
                  <td>
                    <span class="status-pill" [ngClass]="statusClass(row.status)">
                      {{ row.status || 'UNKNOWN' }}
                    </span>
                  </td>
                  <td>{{ row.message || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #noRows>
            <div class="empty-state">No rows were submitted for this sheet.</div>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</section>
